const terms = {
  title: '使用条款',
  description: 'Plannely 应用和网站的使用条款：你的账号、订阅、你的内容以及服务的使用规则。',
  effectiveLabel: '生效日期：',
  effectiveDate: '2026 年 11 月 5 日',
  appLabel: '应用：',
  privacyPhrases: ['隐私政策'],
  sections: [
    {
      title: '接受本条款',
      body: [
        '本使用条款（“本条款”）适用于你对 Plannely 移动应用和网站 https://plannely.app（统称“本服务”）的使用。本服务由 SEOTIV（“我们”）提供。',
        '创建账号或使用本服务，即表示你同意本条款。如果你不同意，请不要使用本服务。我们的隐私政策（https://plannely.app/privacy-policy ）说明了我们如何处理个人数据，并适用于本服务的运行。',
      ],
    },
    {
      title: '本服务',
      body: [
        'Plannely 是一款个人规划工具。根据平台、版本和方案的不同，它可能包括任务、分类、习惯、提醒、日历视图、专注和锻炼工具，以及设备间同步。',
        '随着本服务的发展，我们可能会添加、更改或移除功能。如果某项更改会明显削减你正在付费使用的功能，我们会尽量通过应用或其他适当方式提前合理告知。',
      ],
    },
    {
      title: '你的账号',
      body: [
        '你可以使用应用提供的方式登录，例如 Google 或 Apple。你有责任保障该账号和你的设备的访问安全，并对你的 Plannely 账号下发生的活动负责。如果你认为有人未经许可访问了你的账号，请尽快通过 support@plannely.app 告知我们。',
        '请确保你提供的信息准确无误。请仅在适用于你的法律允许的范围内使用本服务。',
      ],
    },
    {
      title: '儿童和未成年人',
      body: [
        '如果你尚未达到所在地可以订立具有约束力合同的年龄，则只有在父母或法定监护人许可并参与的情况下才可以使用本服务，并由其代表你接受本条款。我们的隐私政策第 14 节说明了我们如何处理儿童数据。',
      ],
    },
    {
      title: '免费和付费方案',
      body: [
        'Plannely 提供有使用限制的免费方案，以及可选的付费订阅，后者提供更高的限额或附加功能。当前的限额和价格显示在应用中，并可能发生变化。在免费方案中，任务（包括已完成的任务）在你删除之前都会计入任务限额。',
        '订阅由 Apple 或 Google Play 通过你购买时使用的账号销售和收费。除商店规则外，还适用以下规定：',
        [
          '除非你在当前周期结束前至少 24 小时或在商店规定的其他期限内取消，否则订阅会按当时的价格自动续订相同周期。',
          '如果提供免费试用，试用结束后将转为付费订阅，除非你及时取消。价格和试用时长会在你确认购买前显示。',
          '你可以在 Apple 或 Google Play 账号中管理或取消订阅。删除应用或 Plannely 账号不会取消订阅。',
          '退款由商店按其政策处理。我们不处理商店付款，也不会收到你完整的银行卡信息。',
        ],
        '订阅结束后，你的账号将恢复为免费方案。你的数据不会因此被删除，但超出免费限额的功能和内容（例如额外的习惯）可能无法使用，直到你再次订阅。',
      ],
    },
    {
      title: '你的内容',
      body: [
        '你保留对在本服务中创建的任务、笔记、习惯、锻炼和其他内容（“你的内容”）的全部权利。你授予我们有限的、非独占的、全球范围的许可，仅在为你运营、保护和支持本服务所必需的范围内存储、处理、复制和传输你的内容。我们不会将你的内容用于广告，也不会出售。',
        '你应对你的内容负责，并确保你有权使用这些内容。对你至关重要的内容，请自行保留一份副本。',
        '如果你创建了锻炼计划的分享链接，任何拥有该链接的人都可以查看和复制该计划，直到链接过期或被你撤销。请只与你信任的人分享链接，不要在分享的内容中放入隐私信息。',
      ],
    },
    {
      title: '可接受的使用',
      body: [
        '使用本服务时，你同意不会：',
        [
          '违反法律或侵犯他人权利；',
          '存储或分享非法、有害或滥用性的内容，包括通过分享链接；',
          '未经授权访问或试图访问本服务、其他账号或我们的系统；',
          '干扰本服务、使其过载，或规避方案限额和其他技术限制；',
          '对本服务进行逆向工程，但法律不顾此限制仍允许的情况除外；',
          '未经我们书面许可，以自动化方式从本服务提取数据；',
          '未经我们书面许可，转售本服务或以商业方式再分发本服务。',
        ],
      ],
    },
    {
      title: '提醒和可用性',
      body: [
        '我们努力保持本服务可靠，但提醒和同步取决于你的设备及其设置、你的网络，以及 Apple 和 Google 等第三方服务。通知可能延迟或无法送达。对于错过通知可能造成伤害或严重损失的事项（例如服药），请不要将本服务作为唯一的提醒方式。',
        '本服务可能因维护、更新或我们无法控制的事件而暂时不可用。',
      ],
    },
    {
      title: '健康和锻炼',
      body: [
        '锻炼、专注和习惯功能是一般性的自我管理工具，不构成医疗建议、诊断或治疗。在开始或改变锻炼计划之前，请咨询合格的医疗专业人员，尤其是在你有健康问题时。如果感到疼痛、头晕或不适，请停止锻炼。在法律允许的范围内，你使用这些功能的风险由你自行承担。',
      ],
    },
    {
      title: '我们的知识产权',
      body: [
        '本服务（包括其软件、设计、名称和标志）归我们或我们的许可方所有，并受知识产权法保护。我们授予你个人的、有限的、非独占的、不可转让且可撤销的许可，以便你根据本条款按预期用途使用本服务。你的内容仍然归你所有。',
        '如果你向我们发送反馈或想法，我们可以使用它们，而无需对你承担任何义务。',
      ],
    },
    {
      title: '第三方服务',
      body: [
        '本服务依赖第三方提供登录、付款、通知和托管等功能。第三方提供的服务适用其自身的条款和隐私政策。对于我们无法控制的第三方服务的可用性或行为，我们不承担责任。',
      ],
    },
    {
      title: '停止使用本服务',
      body: [
        '你可以随时停止使用本服务，并在应用中或发送邮件至 support@plannely.app 删除账号。账号删除的说明见我们的隐私政策。请记得另行取消商店中的订阅。',
        '如果你严重或多次违反本条款，你的使用对本服务或他人造成风险，或法律有此要求，我们可能会暂停或关闭账号。在适当且允许的情况下，我们会告知原因，并给予你解决问题的机会。如果我们终止本服务，我们会尽量提前合理通知。',
      ],
    },
    {
      title: '免责声明',
      body: [
        '在法律允许的最大范围内，本服务按“现状”和“可用”的状态提供。我们不保证本服务不会中断、没有错误或适合特定用途，也不保证数据绝不会丢失。根据适用于你的法律不得限制的保证或消费者权利，本条款中的任何内容均不加以限制。',
      ],
    },
    {
      title: '责任限制',
      body: [
        '在法律允许的最大范围内，我们不对间接、附带、特殊或后果性损害承担责任，也不对利润损失、数据丢失或错过的事件承担责任。对于付费方案，我们就与本服务有关的任何索赔承担的总责任，以你在引发索赔的事件发生前 12 个月内为本服务支付的金额为限。对于免费方案，以相当于 50 美元的金额为限。',
        '上述限制不适用于法律规定不得排除或限制的责任，例如欺诈、故意不当行为，以及法律有规定时因疏忽造成的死亡或人身伤害。',
      ],
    },
    {
      title: '从 Apple App Store 下载的应用',
      body: [
        '如果你从 Apple App Store 下载 Plannely，还适用以下附加条款：',
        [
          '本条款由你与 SEOTIV 订立，而不是与 Apple 订立。SEOTIV（而非 Apple）对应用及其内容承担全部责任。',
          '你的许可仅限于按照 Apple 媒体服务条款中使用规则的允许，在你拥有或控制的 Apple 品牌设备上使用本应用。',
          'Apple 没有义务为本应用提供维护或支持。',
          '如果本应用不符合适用的保证，你可以通知 Apple，Apple 将退还购买价款（如有）。在法律允许的最大范围内，Apple 对本应用不承担其他保证义务。',
          'Apple 不负责处理与本应用或你使用本应用有关的索赔，包括产品责任、法律或监管合规、消费者保护或隐私方面的索赔。',
          'Apple 不负责调查、抗辩、和解或解决任何第三方提出的关于本应用或你使用本应用侵犯知识产权的索赔。',
          '你确认你不位于受美国政府禁运或被美国政府认定为“支持恐怖主义”的国家，也未被列入美国政府的任何禁止或受限方名单。',
          '使用本应用时，你必须遵守适用的第三方条款。',
          'Apple 及其子公司是本条款的第三方受益人，可以对你执行本条款。',
        ],
      ],
    },
    {
      title: '本条款的更改',
      body: [
        '我们可能会随着本服务或法律的变化更新本条款。最新版本及其生效日期始终发布在 https://plannely.app/terms 。如果更改属于重大更改，我们会尽量通过应用或其他适当方式提前告知。在更改生效后继续使用本服务，即表示你接受更新后的条款。如果你不同意，请停止使用本服务并删除账号。',
      ],
    },
    {
      title: '适用法律和争议',
      body: [
        '请先与我们联系，以便我们尝试以非正式方式解决问题。本条款受 SEOTIV 设立地所在国家的法律管辖，不考虑法律冲突规则。这不会剥夺你根据居住国消费者法律享有的任何强制性保护，包括向这些法律规定的法院提起诉讼的权利。',
        '如果本条款的任何部分被认定为不可执行，其余部分继续有效。我们未立即执行某项规定，并不代表放弃日后执行的权利。未经我们同意，你不得转让你在本条款下的权利。我们可以在本服务重组或出售时转让我们的权利，但不会减损你的权利。',
        '我们提供本条款的翻译版本是为了方便你阅读。如果翻译版本与英文版本存在差异，以英文版本为准，除非你所在国家的法律另有规定。',
      ],
    },
    {
      title: '联系方式',
      body: [
        '如果你对本条款有任何疑问，请发送邮件至 support@plannely.app。',
      ],
    },
  ],
};

export default terms;
